"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _iconLibrary = require("./icon-library");

var _metrics = require("../../_helpers/metrics");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Icon.css");

var _styles = {
  "icon": "Icon__icon___1O7Pc",
  "button": "Icon__button___KOpV6"
};

const styles = _bind.default.bind(_styles);

const Icon = (0, _mobxReact.observer)(({
  className,
  name: Path,
  size = 24,
  viewBoxSize = 24,
  color = _.Color.neutral._90,
  dataTestId,
  onClick,
  disabled,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('icon', {
    button: onClick
  }), className);
  return onClick ? _react.default.createElement("button", {
    className: composed_classname,
    type: 'button',
    onClick: () => {
      if (dataTestId) {
        (0, _metrics.trackAction)(`click on ${dataTestId}`);
      }

      if (onClick) {
        onClick();
      }
    },
    disabled: disabled,
    "data-testid": dataTestId,
    ...props
  }, _react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: `0 0 ${viewBoxSize} ${viewBoxSize}`,
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react.default.createElement("path", {
    d: _iconLibrary.IconPath[Path],
    fill: color
  }))) : _react.default.createElement("svg", {
    className: composed_classname,
    width: size,
    height: size,
    viewBox: `0 0 ${viewBoxSize} ${viewBoxSize}`,
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    ...props
  }, _react.default.createElement("path", {
    d: _iconLibrary.IconPath[Path],
    fill: color
  }));
});
var _default = Icon;
exports.default = _default;